import React from 'react';

// Using inline SVG for simplicity as requested by lucide-react docs for no-dependency usage
export const Icon: React.FC<{ children: React.ReactNode, className?: string }> = ({ children, className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        {children}
    </svg>
);

export const UploadCloud: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
        <path d="M12 12v9" />
        <path d="m16 16-4-4-4 4" />
    </Icon>
);

export const LayoutDashboard: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <rect width="7" height="9" x="3" y="3" rx="1" />
        <rect width="7" height="5" x="14" y="3" rx="1" />
        <rect width="7" height="9" x="14" y="12" rx="1" />
        <rect width="7" height="5" x="3" y="16" rx="1" />
    </Icon>
);

export const FileText: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
        <path d="M10 9H8" />
        <path d="M16 13H8" />
        <path d="M16 17H8" />
    </Icon>
);

export const BarChart2: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <line x1="18" x2="18" y1="20" y2="10" />
        <line x1="12" x2="12" y1="20" y2="4" />
        <line x1="6" x2="6" y1="20" y2="14" />
    </Icon>
);

export const Bell: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </Icon>
);

export const Bold: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M14 12a4 4 0 0 0 0-8H6v8" />
        <path d="M15 20a4 4 0 0 0 0-8H6v8Z" />
    </Icon>
);

export const BrainCircuit: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M12 5a3 3 0 1 0-5.998.001A3 3 0 0 0 12 5zm-2.5 6a2.5 2.5 0 1 0-5 .001 2.5 2.5 0 0 0 5-.001m5 4a2 2 0 1 0-3.999.001A2 2 0 0 0 14.5 15m4-5a2.5 2.5 0 1 0-5 .001 2.5 2.5 0 0 0 5-.001m-10-4.5a.5.5 0 1 0-1 .001A.5.5 0 0 0 8.5 5.5m3 4a.5.5 0 1 0-1 .001.5.5 0 0 0 1-.001m6 2.5a.5.5 0 1 0-1 .001.5.5 0 0 0 1-.001M12 9.5v-1m-5 4.5v-1m2.5 5.5v-1m-2.5-4h-1m1.5-3.5h-1m4.5 2h-1m2 2h-1M9 13H7.5a1.5 1.5 0 0 0 0 3H9m3-1h1.5a1.5 1.5 0 0 1 0 3H12m-2.5-5.5.5-1.5m2.5 3.5.5-1.5m-5 3.5.5-1.5" />
    </Icon>
);

export const ChevronRight: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="m9 18 6-6-6-6" />
    </Icon>
);

export const Plus: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M5 12h14" />
        <path d="M12 5v14" />
    </Icon>
);

export const Table: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M12 3v18" />
        <rect width="18" height="18" x="3" y="3" rx="2" />
        <path d="M3 9h18" />
        <path d="M3 15h18" />
    </Icon>
);

export const Trash2: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M3 6h18" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <line x1="10" x2="10" y1="11" y2="17" />
        <line x1="14" x2="14" y1="11" y2="17" />
    </Icon>
);

export const GripVertical: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <circle cx="9" cy="12" r="1" />
        <circle cx="9" cy="5" r="1" />
        <circle cx="9" cy="19" r="1" />
        <circle cx="15" cy="12" r="1" />
        <circle cx="15" cy="5" r="1" />
        <circle cx="15" cy="19" r="1" />
    </Icon>
);

export const Settings: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 0 2l-.15.08a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.38a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1 0-2l.15-.08a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
        <circle cx="12" cy="12" r="3" />
    </Icon>
);

export const AlertTriangle: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" x2="12" y1="9" y2="13" />
        <line x1="12" x2="12.01" y1="17" y2="17" />
    </Icon>
);

export const Lightbulb: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M15 14c.2-1 .7-1.7 1.5-2.5C17.7 10.2 18 9 18 7c0-2.2-1.8-4-4-4S10 4.8 10 7c0 2 .3 3.2 1.5 4.5.8.8 1.3 1.5 1.5 2.5" />
        <path d="M9 18h6" />
        <path d="M10 22h4" />
    </Icon>
);

export const PieChart: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
        <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </Icon>
);

export const X: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
    </Icon>
);

export const Sparkles: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-1-1.732a2 2 0 0 0-3.465 0l-1 1.732A2 2 0 0 0 4.5 17.5h2a2 2 0 0 0 1.732-1l1-1.732a2 2 0 0 0 0-3.465l-1-1.732A2 2 0 0 0 6.5 6.5h-2A2 2 0 0 0 3.036 8.5l1 1.732a2 2 0 0 0 0 3.465l1 1.732A2 2 0 0 0 6.5 17.5h1" />
        <path d="M21 12a2 2 0 0 0-1.732-1l-1-1.732a2 2 0 0 0-3.465 0l-1 1.732A2 2 0 0 0 12.5 12h1" />
        <path d="M17.5 17.5h1a2 2 0 0 0 1.536-2.464l-1-1.732a2 2 0 0 0-3.465 0l-1 1.732A2 2 0 0 0 14.5 17.5h1" />
        <path d="M14.063 3.5A2 2 0 0 0 15.5 4.937l1 1.732a2 2 0 0 0 3.465 0l1-1.732A2 2 0 0 0 19.5 1.5h-2a2 2 0 0 0-1.732 1Z" />
    </Icon>
);

export const MessageSquare: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </Icon>
);

export const FileUp: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
        <path d="M12 12v-1" />
        <path d="m15 14-3-3-3 3" />
    </Icon>
);

export const Globe: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
        <path d="M2 12h20" />
    </Icon>
);

export const Share2: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
        <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
    </Icon>
);

export const Camera: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
        <circle cx="12" cy="13" r="3" />
    </Icon>
);

export const UserCircle: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="10" r="4" />
        <path d="M12 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </Icon>
);

export const MoreVertical: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <circle cx="12" cy="12" r="1" />
        <circle cx="12" cy="5" r="1" />
        <circle cx="12" cy="19" r="1" />
    </Icon>
);

export const Folder: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
    </Icon>
);

export const AreaChart: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M3 3v18h18" />
        <path d="M7 12l5-5 5 7-5 3z" />
    </Icon>
);

export const ScatterChart: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
        <circle cx="18" cy="5" r=".5" fill="currentColor" />
        <circle cx="12" cy="12" r=".5" fill="currentColor" />
        <circle cx="4" cy="17" r=".5" fill="currentColor" />
        <circle cx="19" cy="16" r=".5" fill="currentColor" />
    </Icon>
);

export const Type: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <polyline points="4 7 4 4 20 4 20 7" />
        <line x1="9" x2="15" y1="20" y2="20" />
        <line x1="12" x2="12" y1="4" y2="20" />
    </Icon>
);

export const Info: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4" />
        <path d="M12 8h.01" />
    </Icon>
);

export const Edit2: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    </Icon>
);

export const Copy: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
    </Icon>
);

export const LogOut: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
    </Icon>
);

export const Wand2: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.71 0L11.5 9.51l-7.35 7.35a2.12 2.12 0 0 0 3 3L14.49 12.5l7.15-7.15a1.21 1.21 0 0 0 0-1.71z" />
        <path d="m6.5 12.5 5 5" />
        <path d="M19 5 14 10" />
        <path d="m5 19 6-6" />
        <path d="m13 21 6-6" />
        <path d="M3 3 1.5 1.5" />
        <path d="M22.5 22.5 21 21" />
    </Icon>
);

export const Save: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
        <polyline points="17 21 17 13 7 13 7 21" />
        <polyline points="7 3 7 8 15 8" />
    </Icon>
);

export const Search: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
    </Icon>
);

export const Minus: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <path d="M5 12h14" />
    </Icon>
);

export const SeparatorHorizontal: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <line x1="3" x2="21" y1="12" y2="12" />
        <polyline points="8 8 12 4 16 8" />
        <polyline points="16 16 12 20 8 16" />
    </Icon>
);

export const SeparatorVertical: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <line x1="12" x2="12" y1="3" y2="21" />
        <polyline points="8 8 4 12 8 16" />
        <polyline points="16 16 20 12 16 8" />
    </Icon>
);

export const AlignLeft: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <line x1="17" x2="3" y1="18" y2="18" />
        <line x1="21" x2="3" y1="12" y2="12" />
        <line x1="17" x2="3" y1="6" y2="6" />
    </Icon>
);

export const AlignCenter: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <line x1="18" x2="6" y1="12" y2="12" />
        <line x1="21" x2="3" y1="6" y2="6" />
        <line x1="21" x2="3" y1="18" y2="18" />
    </Icon>
);

export const AlignRight: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <line x1="21" x2="7" y1="18" y2="18" />
        <line x1="21" x2="3" y1="12" y2="12" />
        <line x1="21" x2="7" y1="6" y2="6" />
    </Icon>
);

export const Italic: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <line x1="19" x2="10" y1="4" y2="4" />
        <line x1="14" x2="5" y1="20" y2="20" />
        <line x1="15" x2="9" y1="4" y2="20" />
    </Icon>
);

export const Database: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <ellipse cx="12" cy="5" rx="9" ry="3" />
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    </Icon>
);

export const Check: React.FC<{ className?: string }> = ({ className }) => (
    <Icon className={className}>
        <polyline points="20 6 9 17 4 12" />
    </Icon>
);
